import * as React from 'react';
import useClickOutside from '../../Hooks/useClickOutside';
import { AnimatePresence, motion } from "framer-motion"
import { useDropzone, FileWithPath } from 'react-dropzone';
import { formatBytes } from '../../Hooks/bytesToMB';


import './RequestForVerify.scss';
export interface IRequestForVerificationProps {
}

export function RequestForVerification(props: IRequestForVerificationProps) {

    const [bundleItemsDropOpen, setBundleItemsDropOpen] = React.useState(false)
    const [bundleItmesText, setBundleItmesText] = React.useState('+91');
    let bundleItemsRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(bundleItemsRef, () => setBundleItemsDropOpen(false))


    // 1st Drag and drop functionality------------------
    const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
        accept: 'image/gif,image/png,image/webp,video/mp4,video/mp3',
        maxSize: 100000000,
    });
    const files = acceptedFiles.map((file: any) => (
        <span
            className="text-cusBlueWhite"
            key={file.path}>
            {file.path} - {formatBytes(file.size)}
        </span>
    ));



    const [submitionModal, setSubmitionModal] = React.useState(false)
    const submitionModalRef = React.useRef(null)
    useClickOutside(submitionModalRef, () => setSubmitionModal(false))




    // Choose APR Level
    const [aprLevelDropOpen, setAPRLevelDropOpen] = React.useState(false);
    const [aprLevelText, setAPRLevelText] = React.useState<any>('Select...')
    const aprLevelRef = React.useRef<HTMLHeadingElement>(null);
    useClickOutside(aprLevelRef, () => setAPRLevelDropOpen(false))


    // Choose subscription period
    const [subsPeriodDropOpen, setSubsPeriodDropOpen] = React.useState(false);
    const [subsPeriodText, setSubsPeriodText] = React.useState<any>('Select...')
    const subsPeriodRef = React.useRef<HTMLHeadingElement>(null);
    useClickOutside(subsPeriodRef, () => setSubsPeriodDropOpen(false))




    return (
        <div className="mb-24 mt-24 sm:mt-40 max-w-xl lg:max-w-2xl xl:max-w-3xl mx-auto text-left requestForPreview_main_box p-4">
            <div className="text-left">
                <h1 className="text-xl sm:text-2xl xl:text-3xl font-extrabold text-cusBlack dark:text-white">Become a verified NFT artist</h1>
                <p className="xs:text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2 w-full sm:w-10/12 lg:w-full">To become an UNC exclusive artist submit the following details</p>
            </div>



            <div className="mt-9" >
                <h5 className="text-cusBlack dark:text-white font-semibold text-sm sm:text-base md:text-lg lgtext-xl">Verify Phone Number</h5>


                <div className="flex justify-between items-center mt-2">

                    <button type="button" className="lightBlueBg min-w-[80px] sm:min-w-[100px] flex-1 w-full mr-2 sm:mr-3 h-full px-3 py-4 sm:p-5 rounded-md md:rounded-lg lg:rounded-xl transition-all cursor-pointer relative text-left "
                        onClick={() => setBundleItemsDropOpen(!bundleItemsDropOpen)}>
                        <div className="flex justify-between items-center break-all">
                            <h4 className="text-l-LightBlack dark:text-white font-semibold text-xxs md:text-sm lg:text-base ">{bundleItmesText}</h4>
                            <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 blackWhiteSVG3 transition-all ${bundleItemsDropOpen && 'rotate-180'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                        <AnimatePresence>
                            {bundleItemsDropOpen &&
                                <motion.div
                                    animate={bundleItemsDropOpen ? "open" : "closed"}
                                    initial={{ y: -15, }}
                                    variants={{
                                        open: { y: 0, },
                                        closed: { y: -100, },
                                    }}
                                    exit={{ opacity: 0, }}
                                    transition={{ duration: 0.2 }}
                                    ref={bundleItemsRef}
                                    className="rounded-xl absolute top-16 bg-white dark:bg-[#292757] shadow-lg max-h-[300px] overflow-auto
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0" style={{ zIndex: 999 }}>
                                    {["+91", "+93", "+20", "+210", "+211", "+212", "+213", "+214", "+215", "+216", "+217", "+218", "+219", "+220", "+221", "+222", "+223", "+224", "+225", "+226", "+227", "+228", "+229", "+230", "+231", "+232", "+233", "+234", "+235", "+236", "+237", "+238", "+239", "+240", "+241",].map(item =>
                                        <div onClick={() => { setBundleItmesText(item) }}
                                            className="py-3 px-4 hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all" key={item}>
                                            <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium whitespace-nowrap">{item}</p>
                                        </div>
                                    )}
                                </motion.div>}
                        </AnimatePresence>
                    </button>


                    <div className="lightBlueBg py-2 pl-3 sm:pl-5 pr-2 rounded-xl w-full flex justify-between items-center">
                        <input type="number" name="" id="" placeholder='Enter Phone Number'
                            onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                            className="bg-transparent w-full h-full outline-none text-cusBlack dark:text-white text-xs sm:text-base" />

                        <button className="uppercase text-l-LightBlack dark:text-cusBlueWhite font-bold text-xs sm:text-base md:text-lg
                        bg-[#F2F2F2] dark:bg-[#363375] px-3 py-2 sm:px-4 sm:py-2.5 rounded-md whitespace-nowrap">
                            Send otp
                        </button>
                    </div>
                </div>



                <div className="mt-6">
                    <h5 className="text-cusBlack dark:text-white font-semibold text-sm sm:text-base md:text-lg lgtext-xl">Verify Email</h5>

                    <div className="lightBlueBg py-2 pl-5 pr-2 rounded-xl w-full col-span-5 flex justify-between items-center mt-2">
                        <input type="email" name="" id="" placeholder='Enter Email'
                            className="bg-transparent w-full h-full outline-none text-cusBlack dark:text-white text-xs sm:text-base" />

                        <button className="uppercase text-l-LightBlack dark:text-cusBlueWhite font-bold text-xs sm:text-base md:text-lg
                        bg-[#F2F2F2] dark:bg-[#363375] px-3 py-2 sm:px-4 sm:py-2.5 rounded-md whitespace-nowrap">
                            Send otp
                        </button>
                    </div>
                </div>



                <div className="mt-6">
                    <h5 className="text-cusBlack dark:text-white font-semibold text-sm sm:text-base md:text-lg lgtext-xl">Choose APR Level</h5>

                    <div
                        ref={aprLevelRef}
                        onClick={() => setAPRLevelDropOpen(!aprLevelDropOpen)}
                        className="relative">
                        <div className=" flex justify-between items-center relative lightBlueBg p-5 rounded-xl mt-2 cursor-pointer" style={{ zIndex: 0 }}>
                            <p className="text-cusBlack dark:text-white font-semibold dark:font-medium text-xs  break-all sm:text-sm">{aprLevelText}</p>

                            <svg xmlns="http://www.w3.org/2000/svg" className={`${aprLevelDropOpen ? 'rotate-180' : ''} transition-all h-3.5 w-3.5 sm:h-5 sm:w-5 blackWhiteSVG3`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                        <AnimatePresence>
                            {aprLevelDropOpen &&
                                <motion.div
                                    animate={aprLevelDropOpen ? "open" : "closed"}
                                    variants={{
                                        open: { opacity: 1, y: 4 },
                                        closed: { opacity: 0, y: -10, },
                                    }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.3 }}
                                    className="absolute right-0 top-14 w-full bg-white shadow-xl dark:bg-[#363375] rounded " style={{ zIndex: 3 }}>

                                    {["Entry level", "Intermediate level", "Expert level",].map(level =>
                                        <button
                                            className="w-full py-3 hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 flex justify-start items-center transition-all"
                                            onClick={() => setAPRLevelText(level)}
                                            key={level}
                                        >
                                            <p className="text-l-LightBlack dark:text-white text-sm font-semibold ml-2">{level}</p>
                                        </button>
                                    )}

                                </motion.div>}
                        </AnimatePresence>
                    </div>
                </div>



                <div className="mt-6">
                    <h5 className="text-cusBlack dark:text-white font-semibold text-sm sm:text-base md:text-lg lgtext-xl">Choose subscription period</h5>

                    <div
                        ref={subsPeriodRef}
                        onClick={() => setSubsPeriodDropOpen(!subsPeriodDropOpen)}
                        className="relative" >
                        <div className=" flex justify-between items-center lightBlueBg p-5 rounded-xl mt-2 relative cursor-pointer" style={{ zIndex: 0 }}>
                            <p className="text-cusBlack dark:text-white font-semibold dark:font-medium text-xs  break-all sm:text-sm">{subsPeriodText}</p>

                            <svg xmlns="http://www.w3.org/2000/svg" className={`${subsPeriodDropOpen ? 'rotate-180' : ''} transition-all h-3.5 w-3.5 sm:h-5 sm:w-5 blackWhiteSVG3`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                        <AnimatePresence>
                            {subsPeriodDropOpen &&
                                <motion.div
                                    animate={subsPeriodDropOpen ? "open" : "closed"}
                                    variants={{
                                        open: { opacity: 1, y: 4 },
                                        closed: { opacity: 0, y: -10, },
                                    }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.3 }}
                                    className="absolute right-0 top-14 w-full bg-white shadow-xl dark:bg-[#363375] rounded">

                                    {["Subscription period 1", "Subscription period 2", "Subscription period 3",].map(level =>
                                        <button
                                            className="w-full py-3 hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 flex justify-start items-center transition-all"
                                            onClick={() => setSubsPeriodText(level)}
                                            key={level}
                                        >
                                            <p className="text-l-LightBlack dark:text-white text-sm font-semibold ml-2">{level}</p>
                                        </button>
                                    )}

                                </motion.div>}
                        </AnimatePresence>
                    </div>
                </div>












                <div className="mt-6">
                    <h5 className="text-cusBlack dark:text-white font-semibold text-sm sm:text-base md:text-lg lgtext-xl">Submit ID Proof</h5>

                    <p className="xs:text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2 w-full sm:w-10/12 lg:w-full">Submit your countries official Identification by clicking a selfie with your document next to you</p>


                    <div {...getRootProps({ className: 'dropzone' })}>
                        <input {...getInputProps()} />
                        <div className="bg-[#ffffff] dark:bg-[#0E0631] border-2 border-dashed border-[#D8D8D8] dark:border-[#3d3892] py-10 p-3 mt-3 rounded-xl text-center">
                            {files.length !== 0
                                ? <p className="text-cusBlack dark:text-white xs:text-xxs sm:text-base">Your File: {files}</p>
                                : fileRejections.length !== 0
                                    ? <p className="text-red-500 dark:text-red-400 xs:text-xxs sm:text-base">{fileRejections[0]?.errors[0]?.message}</p>
                                    : <p className="text-l-LightBlack dark:text-cusBlueWhite xs:text-xxs sm:text-base">PNG, GIF, WEBP, MP4 or MP3. Max 100mb.</p>
                            }
                            <button
                                className="font-semibold dark:font-medium bg-cusBrightLink dark:bg-black mt-6 text-cusLightLink dark:text-cusLink xs:px-4 sm:px-6 xs:py-1 sm:py-3 rounded-full xs:text-xs sm:text-base">
                                Choose file
                            </button>
                        </div>
                    </div>
                </div>



                <button
                    onClick={() => setSubmitionModal(true)}
                    className="xs:text-sm md:text-lg font-semibold text-white mt-5 xs:p-4 sm:p-6 xl:p-7 2xl:p-8 w-full rounded-xl  gradientBtn">
                    Submit for verification
                </button>










                <AnimatePresence>
                    {submitionModal &&
                        <div className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                            <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                                <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                                <motion.div
                                    animate={submitionModal ? "open" : "closed"}
                                    initial={{ scale: 0.7 }}
                                    variants={{
                                        open: { scale: 1 },
                                        closed: { scale: 0.9 },
                                    }}
                                    exit={{ scale: 0, y: -100 }}
                                    transition={{ duration: 0.1 }}
                                    ref={submitionModalRef} className="relative inline-block align-bottom listening_modal_gredi_box rounded-xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md w-full">
                                    <div className="listening_modal rounded-2xl bg-white dark:bg-[#292757] py-5 px-7">

                                        <div className="flex justify-end items-center">

                                            <button onClick={() => setSubmitionModal(false)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 md:w-auto stroke-[#00000060] dark:stroke-white" width="21.855" height="21.856" viewBox="0 0 21.855 21.856">
                                                    <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="" strokeLinecap="round" strokeWidth={3} />
                                                    <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="" strokeLinecap="round" strokeWidth={3} />
                                                </svg>
                                            </button>
                                        </div>

                                        <p className="text-xl text-cusBlack dark:text-white w-full sm:w-9/12 mx-auto text-center mt-4">Thanks for the submission, our internal team will review and get back to you </p>


                                        <div className="text-center mt-6">
                                            <button className="text-[#915DF1] text-center"
                                                onClick={() => setSubmitionModal(false)}>
                                                Thanks
                                            </button>
                                        </div>

                                    </div>
                                </motion.div>
                            </div>
                        </div>}
                </AnimatePresence>



            </div>

        </div >
    );
}


